import { render } from "./QueryBuilderGroups.vue?vue&type=template&id=50ea1d21"
import script from "./QueryBuilderGroups.vue?vue&type=script&lang=js"
export * from "./QueryBuilderGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__